import { BLOCKS, INLINES } from '@contentful/rich-text-types'
import { intersection } from 'lodash-es'

import type { RichTextOptions, RichTextElementProps } from './types'

export const warnAboutOptionIssues = (options: RichTextOptions) => {
  if (options.extraProps && options.renderNode) {
    const conflictingKeys = intersection(
      Object.keys(options.renderNode),
      Object.keys(options.extraProps),
    )

    if (conflictingKeys.length > 0) {
      console.error(
        `RichText.options was provided conflicting keys for extraProps and renderNode. If a component is overridden by renderNode, props for that element will not be applied.`,
        { conflictingKeys },
      )
    }
  }
}

export const defaultRichTextPropOptions: RichTextElementProps = {
  [BLOCKS.HEADING_1]: {},
  [BLOCKS.HEADING_2]: {},
  [BLOCKS.HEADING_3]: {},
  [BLOCKS.HEADING_4]: {},
  [BLOCKS.HEADING_5]: {},
  [BLOCKS.HEADING_6]: {},
  [BLOCKS.OL_LIST]: {},
  [BLOCKS.UL_LIST]: {},
  [BLOCKS.LIST_ITEM]: {},
  [BLOCKS.QUOTE]: {},
  [BLOCKS.PARAGRAPH]: {},
  [BLOCKS.TABLE]: {},
  [INLINES.HYPERLINK]: {},
  [INLINES.ENTRY_HYPERLINK]: {},
  [INLINES.ASSET_HYPERLINK]: {},
}
